exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.floor .el-tabs__header {\n  margin: 0;\n  border-bottom: 1px solid #d4d4d4;\n}\n.floor .el-tabs__content {\n  display: none;\n}\n.floor .el-tabs__nav {\n  float: right;\n}\n.floor .el-tabs__nav {\n  border: none !important;\n}\n.floor .el-tabs__nav > div {\n    margin-right: 10px;\n    border: 1px solid #d4d4d4;\n    border-left: 1px solid #d4d4d4 !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-62ace5a6","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/theme.scss","/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/_mixin.scss"]}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/view/pc/custompage/components/plugins/floor/index.vue
// module id = 1538
// module chunks = 0